import React from 'react'
import {KeyboardDatePicker} from '@material-ui/pickers'

export const DatePickerField = ({ field, form, ...other }) => {
  const error = form.errors[field.name]
  const touched = form.touched[field.name]

  return (
    <KeyboardDatePicker
      {...other}
      clearable
      disableFuture
      disabled={form.isSubmitting}
      name={field.name}
      value={field.value}
      format="dd/MM/yyyy"
      error={touched && error}
      helperText={touched && error}
      // if you are using custom validation schema you probably want to pass `true` as third argument
      onChange={date => form.setFieldValue(field.name, date, false)}
    />
  );
};
